"use client";

import { Product } from "@/actions/schemas/products";
import { Store } from "@/actions/schemas/stores";
import { ProductCard } from "@/components/product-card";
import { Divider, Feedback, GroupHeader } from "@stone-payments/jade";

type Props = {
  store: Store;
  suggestions: Product[];
  onClickProduct: () => void;
};

export const EmptyCart = ({ store, suggestions, onClickProduct }: Props) => (
  <>
    <div className="flex h-90 justify-center">
      <Feedback variant="neutral" title="Seu carrinho está vazio" icon="cart" />
    </div>

    {suggestions.length > 0 ? (
      <div className="mt-auto">
        <GroupHeader title="Sugestões para você" as="div" />

        <div className="px-jade-250">
          <Divider />
        </div>

        <div className="grid w-full grid-cols-2 items-start gap-4 p-jade-150">
          {suggestions?.map((product) => (
            <ProductCard
              className="h-full"
              key={product.id}
              data={product}
              store={store}
              layout="grid"
              onClick={onClickProduct}
              hasBorder={false}
              showCartButton={false}
            />
          ))}
        </div>
      </div>
    ) : null}
  </>
);
